import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

import { LoadingComponent } from '../loading/LoadingComponent';
import { ArrowCarouselComponent } from './ArrowCarouselComponent';

import 'slick-carousel/slick/slick.css';
import { CarrouselContainer } from './CarouselComponentStyle';

class CarouselComponent extends React.Component {
    defaultOptions = () => ({
        prevArrow: (
            <ArrowCarouselComponent classNameContainer="fleche-g" isLeft onClick={this.prevItem} />
        ),
        nextArrow: <ArrowCarouselComponent classNameContainer="fleche-d" onClick={this.nextItem} />
    });

    prevItem = e => this.carousel.slickPrev();
    nextItem = e => this.carousel.slickNext();

    renderCarrousel = () => {
        const { children } = this.props;
        if (children && children.length > 0) {
            return (
                <Slider {...{ ...this.defaultOptions(), ...this.props.options }}>{children}</Slider>
            );
        } else {
            return (
                <div className="flex-container-v flex-center" id="loading">
                    <LoadingComponent />
                </div>
            );
        }
    };

    render() {
        return <CarrouselContainer id={this.props.id}>{this.renderCarrousel()}</CarrouselContainer>;
    }
}

CarouselComponent.propTypes = {
    children: PropTypes.node,
    options: PropTypes.object
};

export default CarouselComponent;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselComponent.js